/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>stock profit and loss calculator 💰</h1>
    </header>
  );
}
export default Header;
